import React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import '../assets/css/PageWrapper.css'; // Ajoutez les styles nécessaires

function PageWrapper({ children, locationKey }) {
    return (
        <TransitionGroup>
            <CSSTransition key={locationKey} classNames="fade" timeout={300}>
                <div className="page">{children}</div>
            </CSSTransition>
        </TransitionGroup>
    );
}

export default PageWrapper;
